/* Fashion CITY — 커스텀 티셔츠 색상 사진
   티셔츠는 스타일마다 가격이 달라서 상품(리스팅)을 두 개로 나눴습니다.

     custom-t-shirt-g5000  — G5000 · 기본 핏, 두꺼운 코튼 저지 · 18색
     custom-t-shirt-c1717  — C1717 · 박시 핏, 가먼트 다이 · 12색

   ★ 색을 넣거나 빼려면 아래 목록만 고치면 됩니다.
     → fc-tee5000-<조각>.jpg / fc-tee1717-<조각>.jpg
   ※ 뒷면 사진은 아직 없습니다. 'Full back' 을 골라도 앞면 사진 위에 미리보기가 뜹니다.

   ── C1717 에서 뺀 색 ──
   Washed Black · Charcoal Navy · Taupe · Crimson · Wine · Bright Red ·
   Light Denim · Medium Denim · Grey Moss · Neon Violet · Neon Lilac ·
   Orchid · Dusty Lilac · Dusty Orchid
   (사진은 콘텐츠 → 파일 에 그대로 남아 있으니 다시 넣고 싶으면
    c('이름', '파일조각') 한 줄만 추가하면 됩니다.)
*/
window.FCPO_STYLES = window.FCPO_STYLES || {};
window.FCPO_PLACE_BY_HANDLE = window.FCPO_PLACE_BY_HANDLE || {};
(function () {
  var H5000 = 'custom-t-shirt-g5000';
  var H1717 = 'custom-t-shirt-c1717';
  var B = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/';
  function g(name, slug) { return [name, B + 'fc-tee5000-' + slug + '.jpg']; }
  function c(name, slug) { return [name, B + 'fc-tee1717-' + slug + '.jpg']; }

  var G5000 = [
    g('Black', 'Black'),
    g('Ash Grey', 'Ash-Grey'),
    g('White', 'White'),
    g('Sand', 'Sand'),
    g('Brown', 'Brown'),
    g('Navy', 'Navy'),
    g('Indigo', 'Indigo'),
    g('Royal', 'Royal'),
    g('Light Blue', 'Light-Blue'),
    g('Purple', 'Purple'),
    g('Burgundy', 'Burgundy'),
    g('Red', 'Red'),
    g('Orange', 'Orange'),
    g('Hot Pink', 'Hot-Pink'),
    g('Light Pink', 'Light-Pink'),
    g('Forest Green', 'Forest-Green'),
    g('Kelly Green', 'Kelly-Green'),
    g('Olive', 'Olive')
  ];

  var C1717 = [
    c('Black', 'Black'),
    c('White', 'White'),
    c('Ivory', 'Ivory'),
    c('Khaki', 'Khaki'),
    c('Espresso', 'Espresso'),
    c('Brick Red', 'Brick-Red'),
    c('True Red', 'True-Red'),
    c('Teal', 'Teal'),
    c('Ice Blue', 'Ice-Blue'),
    c('Denim Blue', 'Denim-Blue'),
    c('Moss Olive', 'Moss-Olive'),
    c('Violet', 'Violet')
  ];

  /* 자수/인쇄 자리 — 두 스타일 사진 프레임이 거의 같아서 같은 값을 씁니다.
     x, y : 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100 (y 가 클수록 아래)
     w    : Medium 일 때 폭 (사진 가로폭의 %)
     ※ 소매(Sleeve) 자리는 뺐습니다. 다시 쓰려면 아래 한 줄을 추가하세요.
       { v: 'Sleeve', x: 14, y: 35, w: 8, sizes: [1.5, 2, 3] }
  */
  function places() {
    return [
      { v: 'Left chest', x: 37, y: 30, w: 13, sizes: [3, 4, 5] },
      { v: 'Full front', x: 50, y: 42, w: 35, sizes: [11, 12, 13] },
      { v: 'Full back',  x: 50, y: 42, w: 35, sizes: [11, 12, 13] }
    ];
  }

  window.FCPO_STYLES[H5000] = {
    styleLabel: 'T-shirt style',
    colorLabel: 'T-shirt color',
    propStyle: 'Style',
    propColor: 'T-shirt color',
    styles: [{ n: 'G5000', sku: '', colors: G5000 }]
  };
  window.FCPO_PLACE_BY_HANDLE[H5000] = places();

  window.FCPO_STYLES[H1717] = {
    styleLabel: 'T-shirt style',
    colorLabel: 'T-shirt color',
    propStyle: 'Style',
    propColor: 'T-shirt color',
    styles: [{ n: 'C1717', sku: '', colors: C1717 }]
  };
  window.FCPO_PLACE_BY_HANDLE[H1717] = places();
})();